import Checkpoint from "./checkpoint";

import FilterCheckpoint from "./filter-checkpoint";
import DelayCheckpoint from "./delay-checkpoint";
import DeduplicationTargetCheckpoint from "./deduplication-target-checkpoint";
import DeduplicationBaseCheckpoint from "./deduplication-base-checkpoint";
import OptionsCheckpoint from "./options-checkpoint";
import FilterExclusionCheckpoint from "./filter-exclusion-checkpoint";
import TimerCheckpoint from "./timer-checkpoint";

const filterCheckpoint = new FilterCheckpoint();
const delayCheckpoint = new DelayCheckpoint();
const deduplicationTargetCheckpoint = new DeduplicationTargetCheckpoint();
const deduplicationBaseCheckpoint = new DeduplicationBaseCheckpoint();
const optionsCheckpoint = new OptionsCheckpoint();
const filterExclusionCheckpoint = new FilterExclusionCheckpoint();
const timerCheckpoint = new TimerCheckpoint();

/**
 * @type {Object.<string, JourneyBuilder.Checkpoint>}
 */
const checkpointDefinitions = {
    [filterCheckpoint.name]: filterCheckpoint,
    [delayCheckpoint.name]: delayCheckpoint,
    [deduplicationTargetCheckpoint.name]: deduplicationTargetCheckpoint,
    [deduplicationBaseCheckpoint.name]: deduplicationBaseCheckpoint,
    [optionsCheckpoint.name]: optionsCheckpoint,
    [filterExclusionCheckpoint.name]: filterExclusionCheckpoint,
    [timerCheckpoint.name]: timerCheckpoint
};

/**
 * @type {JourneyBuilder.Checkpoint[]}
 */
const checkpointDefinitionsArray = [
    deduplicationTargetCheckpoint,
    deduplicationBaseCheckpoint,
    delayCheckpoint,
    filterCheckpoint,
    filterExclusionCheckpoint,
    optionsCheckpoint,
    timerCheckpoint
];

export {
    Checkpoint,
    filterCheckpoint,
    delayCheckpoint,
    deduplicationTargetCheckpoint,
    deduplicationBaseCheckpoint,
    optionsCheckpoint,
    filterExclusionCheckpoint,
    timerCheckpoint,

    checkpointDefinitions,
    checkpointDefinitionsArray
}